import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { recordEscalationReason } from 'services/cm-api/record-escalation-reason'

export function useRecordEscalationReason() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(recordEscalationReason, {
    onSuccess: async () => {
      enqueueSnackbar('Reason recorded successfully', { variant: 'success' })
      // Refetch the list so the edited row's status and reason update in place.
      // The old per-company 'escalationStatus' query is gone with the lookup form.
      await queryClient.invalidateQueries(['listEscalations'])
    },
    onError: () => {
      enqueueSnackbar('Failed to record reason', { variant: 'error' })
    },
  })
}
